import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-content-marketing',
  templateUrl: './service-content-marketing.component.html',
  styleUrls: ['./service-content-marketing.component.css']
})
export class ServiceContentMarketingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
